import { Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type { ClientPropertyItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { propertyListTitle } from "web_myplann/Portfolio/Components/Redesign/ListItem/propertyListTitle";

type Props = {
	data: ClientPropertyItemResponseDTO;
};

export const PropertyTitle: FC<Props> = ({ data }) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<Typography variant="bodyMedium" color={theme.palette.grey[900]} noWrap>
			{propertyListTitle(data, t)}
		</Typography>
	);
};
